import { Box, Link, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { templates } from '@/app/[locale]/Ai-Text-Generator/Text-Generation-Functions/FreeTemplates';
import { HtmlTooltip } from '@/features/components/ToolTip';
import { gotoLogin } from '@/features/Functions/ResultFunctions';
import CrownIcon from '@/features/Icons/CrownIcon';

interface TemplatesIconProps {
  onSelectTemplate: (template: string) => void;
  isPremium?: boolean;
}

const TemplatesIcon: React.FC<TemplatesIconProps> = ({ onSelectTemplate, isPremium = false }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<SVGSVGElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (templateKey: string) => {
    const selectedTemplate = templates[templateKey];
    onSelectTemplate(selectedTemplate);
    handleClose();
  };

  return (
    <div>
      <Tooltip title="Prompt Templates">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="15"
          fill="currentColor"
          viewBox="0 0 19 15"
          onClick={handleClick}
          style={{ cursor: 'pointer' }}
        >
          <path d="M16.964 0H2.036C.916 0 0 1.01 0 2.246V12.73c0 1.236.916 2.247 2.036 2.247h12.472a2.8 2.8 0 0 1-.102-.584c-1.065-.075-1.914-1.041-1.914-2.232 0-1.19.849-2.156 1.914-2.231.061-1.176.936-2.104 2.022-2.104 1.08 0 1.954.928 2.022 2.104.19.015.374.052.55.127v-7.81C19 1.011 18.084 0 16.964 0M11.4 11.396H3.053c-.373 0-.678-.337-.678-.748 0-.412.305-.75.678-.75H11.4c.373 0 .678.338.678.75 0 .411-.305.748-.678.748M2.375 7.787c0-.411.305-.748.678-.748h8.428c.374 0 .679.337.679.748 0 .412-.305.75-.679.75H3.053c-.373 0-.678-.338-.678-.75m13.571-2.171H3.053c-.373 0-.678-.337-.678-.749s.305-.749.678-.749h12.893c.374 0 .679.337.679.75 0 .411-.305.748-.679.748"></path>
          <path d="M18.321 11.41h-1.217v-1.342c0-.413-.303-.748-.678-.748s-.679.335-.679.748v1.343H14.53c-.375 0-.679.335-.679.748 0 .414.304.75.679.75h1.217v1.342c0 .414.304.749.679.749s.678-.335.678-.749v-1.343h1.217c.375 0 .679-.335.679-.749 0-.413-.304-.748-.679-.748"></path>
        </svg>
      </Tooltip>

      {/* Dropdown menu */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {/*<MenuItem onClick={() => handleMenuItemClick('linkedinPost')}>LinkedIn Post</MenuItem>*/}
        {/*<MenuItem onClick={() => handleMenuItemClick('igCaption')}>Instagram Caption</MenuItem>*/}
        {/*<MenuItem onClick={() => handleMenuItemClick('twitterPost')}>Twitter Post</MenuItem>*/}

        {/* Premium Feature Option */}
        <HtmlTooltip
          title={
            <React.Fragment>
              <Typography variant="body2" color="inherit">
                <CrownIcon></CrownIcon>
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <FormattedMessage id="home.text-generator.premium" />
              </Typography>
              <Link
                href="#"
                color="primary"
                onClick={e => {
                  e.preventDefault(); // Prevent the default behavior (which is navigating to a URL)
                  gotoLogin(); // Call the gotoLogin function
                }}
              >
                <FormattedMessage id="home.text-generator.signupnow" />
              </Link>
            </React.Fragment>
          }
        >
          <span>
            <MenuItem
              sx={{
                fontSize: { xs: '0.875rem', sm: '1rem' },
                display: 'flex',
                justifyContent: 'space-between', // Ensure label and icon are in two columns
                alignItems: 'center',
                pointerEvents: !isPremium ? 'none' : 'auto' // Prevents clicking when needed
              }}
              onClick={() => console.log('Clicked more templates')}
            >
              {/* Left side: Grayed-out label */}
              <Typography sx={{ color: !isPremium ? 'text.disabled' : 'inherit' }}>
                <FormattedMessage id="home.text-generator.textarea.templates.premium" />
              </Typography>

              {/* Right side: Fully visible icon */}
              <Box sx={{ opacity: 1, color: 'inherit' }}>
                <CrownIcon />
              </Box>
            </MenuItem>
          </span>
        </HtmlTooltip>
      </Menu>
    </div>
  );
};

export default TemplatesIcon;
